// Theme initialization plugin - NEVER calls initPelzari()
// Components handle their own initialization
export default {
    install(app) {
        // Track what's been initialized globally (only once)
        let globalInitDone = false
        
        // Add global method to process theme elements
        app.config.globalProperties.$initTheme = function() {
            setTimeout(() => {
                if (!window.jQuery) {
                    console.warn('⚠️ jQuery not loaded yet')
                    return
                }
                
                const $ = window.jQuery
                const TweenMax = window.TweenMax
                const TweenLite = window.TweenLite
                
                console.log('🎨 Processing theme elements...')
                
                // Ensure page loader is hidden
                $(".loader-wrap").hide()
                $(".page-load").hide()
                
                // Ensure content is visible
                $("#wrapper, #main, .content").css('opacity', '1')
                
                // ALWAYS process backgrounds on every route
                $('[data-bg]').each(function() {
                    const bg = $(this).attr('data-bg')
                    if (bg) {
                        $(this).css('background-image', 'url(' + bg + ')')
                    }
                })
                
                    // ALWAYS update CSS dimensions
                    if ($(".fixed-column-wrap").length) {
                        $(".fixed-column-wrap").css({
                            height: $(window).outerHeight(true)
                        })
                    }
                    
                    // Set height-emulator to match footer height for scroll reveal
                    if ($(".height-emulator").length && $(".main-footer").length) {
                        $(".height-emulator").css({
                            height: $(".main-footer").outerHeight(true)
                        })
                    }
                
                // Ensure contact form is hidden by default
                $(".contact-form-wrap").hide()
                $(".contact-form-overlay").hide()
                
                // Initialize ONLY truly global elements (not managed by components)
                // These run ONCE and persist across all routes
                if (!globalInitDone) {
                    console.log('🎬 Initializing global elements (cursor, lightbox, share, progress)')
                    
                    // Custom cursor - persists across all pages
                    if ($(".element-item").length > 0 && TweenLite) {
                        const mouse = { x: 0, y: 0 }
                        const pos = { x: 0, y: 0 }
                        const ratio = 0.15
                        const ball = document.querySelector('.element-item')
                        
                        TweenLite.set(ball, {
                            xPercent: -50,
                            yPercent: -50
                        })
                        
                        document.addEventListener("mousemove", function mouseMove(e) {
                            const scrollTop = window.pageYOffset || document.documentElement.scrollTop
                            mouse.x = e.pageX
                            mouse.y = e.pageY - scrollTop
                        })
                        
                        if (TweenMax) {
                            TweenMax.ticker.addEventListener("tick", function updatePosition() {
                                pos.x += (mouse.x - pos.x) * ratio
                                pos.y += (mouse.y - pos.y) * ratio
                                TweenMax.set(ball, { x: pos.x, y: pos.y })
                            })
                        }
                        
                        // Cursor hover effects
                        $(".white-bg").on({
                            mouseenter: function () { $(".element-item").addClass("white_blur") },
                            mouseleave: function () { $(".element-item").removeClass("white_blur") }
                        })
                        $("a , .btn ,   textarea,   input  , .leaflet-control-zoom , .close-contact_form , .nav-button , .swiper-pagination-bullet , .to-top-btn , .hsc , .hsc_pp2 , .hsc_pp , .act-cf").on({
                            mouseenter: function () { $(".element-item").addClass("elem_hover") },
                            mouseleave: function () { $(".element-item").removeClass("elem_hover") }
                        })
                        $(".nav-overlay , .det-overlay").on({
                            mouseenter: function () { $(".element-item").addClass("close-icon") },
                            mouseleave: function () { $(".element-item").removeClass("close-icon") }
                        })
                        
                        console.log('✅ Custom cursor initialized')
                    }
                    
                    // Progress bar
                    $(window).on("scroll", function () {
                        const a = $(document).height()
                        const b = $(window).height()
                        const c = $(window).scrollTop()
                        const d = c / (a - b) * 100
                        $(".progress-bar").css({ height: d + "%" })
                    })
                    
                    // Share functionality
                    if ($.fn.share) {
                        $(".share-container").share({
                            networks: ['facebook', 'pinterest', 'twitter', 'linkedin', 'tumblr']
                        })
                        
                        const shrcn = $(".share-container")
                        const swra = $(".share-wrapper")
                        const clsh = $(".close-share-btn")
                        const shic = $(".share-icon")
                        const ssbtn = $(".showshare")
                        
                        function showShare() {
                            ssbtn.addClass("uncl-share")
                            shrcn.removeClass("isShare")
                            if (TweenMax) {
                                TweenMax.to(swra, 0.9, {
                                    force3D: false,
                                    width: "320px",
                                    ease: window.Expo.easeInOut,
                                    onComplete: function () {
                                        TweenMax.to(clsh, 0.4, { force3D: true, top: "0", opacity: "1" })
                                        shic.each(function (a) {
                                            const boi = $(this)
                                            setTimeout(function () {
                                                TweenMax.to(boi, 1.0, { force3D: false, opacity: "1" })
                                            }, 130 * a)
                                        })
                                    }
                                })
                            }
                        }
                        
                        function hideShare() {
                            ssbtn.removeClass("uncl-share")
                            shrcn.addClass("isShare")
                            if (TweenMax) {
                                TweenMax.to($(".share-icon"), 1.0, { force3D: false, opacity: "0" })
                                TweenMax.to(clsh, 0.4, {
                                    force3D: true,
                                    top: "-60px",
                                    opacity: "0",
                                    onComplete: function () {
                                        TweenMax.to(swra, 0.6, {
                                            force3D: false,
                                            delay: 0.2,
                                            width: "0",
                                            ease: window.Expo.easeInOut
                                        })
                                    }
                                })
                            }
                        }
                        
                        clsh.on("click", function () { hideShare() })
                        ssbtn.on("click", function () {
                            if ($(".share-container").hasClass("isShare")) showShare()
                            else hideShare()
                        })
                        
                        console.log('✅ Share functionality initialized')
                    }
                    
                    // LightGallery
                    if ($.fn.lightGallery) {
                        $(".image-popup").lightGallery({
                            selector: "this",
                            cssEasing: "cubic-bezier(0.25, 0, 0.25, 1)",
                            download: false,
                            counter: false
                        })
                        
                        const o = $(".lightgallery")
                        o.lightGallery({
                            selector: ".lightgallery a.popup-image",
                            cssEasing: "cubic-bezier(0.25, 0, 0.25, 1)",
                            download: false,
                            loop: false,
                            counter: false
                        })
                        
                        console.log('✅ LightGallery initialized')
                    }
                    
                    globalInitDone = true
                    console.log('✅ Global elements initialized')
                } else {
                    console.log('✨ Global scripts already initialized - only processing backgrounds')
                }
                
                console.log('✅ Theme processing complete')
            }, 100)
        }
        
        // Router hook to handle route changes
        if (app.config.globalProperties.$router) {
            // After navigation
            app.config.globalProperties.$router.afterEach((to, from) => {
                console.log('📍 Route:', to.path)
                
                // Scroll to top
                window.scrollTo(0, 0)
                
                // Ensure content stays visible after navigation
                setTimeout(() => {
                    if (window.jQuery) {
                        const $ = window.jQuery
                        // Force content visibility
                        $("#wrapper, #main, .content").css('opacity', '1').show()
                        // Hide ALL loaders and overlays
                        $(".loader-wrap").hide()
                        $(".page-load").hide().removeClass("act_pl")
                        $(".nav-overlay").hide()
                        $(".det-overlay").hide()
                        // Ensure menu is in closed state (but-hol = hidden)
                        $(".nav-holder").addClass("but-hol")
                        $(".nav-button").removeClass("cmenu")
                        console.log('✅ Content visibility ensured, overlays hidden')
                    }
                }, 100)
            })
        }
    }
}
